import { useMutation } from "@tanstack/react-query";
import { type AxiosError } from "axios";

import { QueryKeys, queryClient } from "@/api/core";
import { useApi } from "@/hooks";
import toast from "@/toast";

function useGetOrCreateChatByAccount() {
  const api = useApi();

  return useMutation({
    mutationFn: (accountId: string) =>
      api.post(`/api/v1/pleroma/chats/by-account-id/${accountId}`),
    onError(error: AxiosError) {
      const data = error.response?.data as any;
      if (data?.error) {
        toast.error(data.error);
      }
    },
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: QueryKeys.chats.list() });
    },
  });
}

export { useGetOrCreateChatByAccount };
